import axios from "axios";
import { IDataContext } from "../interfaces/IDataContext";
import { handleMessage } from "../helpers/stateHelper";
import { IUser } from "../interfaces/IUser";
import { ICustomer } from "../interfaces/ICustomer";

export default class UserApi {
  public getById = async (
    dataContext: IDataContext,
    user: IUser,
    t: any
  ): Promise<any> => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/user/getbyid`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: {
            id: user.id,
          },
        }
      );

      if (response?.data) {
        const authenticatedUser: IUser = {
          id: response.data.id,
          title: response?.data?.title ?? "",
          username: response.data.username,
          token: user.token,
        };

        const customers: ICustomer[] = response.data.customers ?? [];
        const selectedCustomer: ICustomer | undefined =
          dataContext.state.selectedCustomer ?? customers[0];

        dataContext.setRootState((prev) => ({
          ...prev,
          authUser: authenticatedUser,
          customers,
          selectedCustomer,
        }));

        return response.data;
      }
      return;
    } catch (error: any) {
      handleMessage(dataContext.setRootState, "error", t("error.userFetch"));
    }
  };
}
